import FileSaver from 'file-saver';
import { useOrderApiV1 } from '../../../clients/quipli-service/order/order-api-v1';
import { OrderList } from '../../order/order-list';
import { DateTime } from 'luxon';
import { Button } from '../../../components/form/button';
import { Typography } from '../../../components/typography/typography';
import Icon from '../../../components/icons/icon';
import { useState } from 'react';
import { toast } from '../../../util/toasts';
import { SpinnerModal } from '../../../components/modal/spinner-modal';

export const MissedRentalsReport = () => {
  const { exportMissedOrders } = useOrderApiV1();

  const [isExporting, setIsExporting] = useState(false);
  const doExport = async () => {
    setIsExporting(true);
    try {
      const file = await exportMissedOrders();
      const exportFileName = `Missed_Orders_Report_${DateTime.local().toFormat('yyyy-LL-dd')}`;
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = '.xlsx';

      const data = new Blob([file], { type: fileType });
      FileSaver.saveAs(data, `${exportFileName}${fileExtension}`);
    } catch (e) {
      console.error(e);
      toast('Failed to export orders', 'error');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <OrderList
        title="Missed Rentals Report"
        createOrderButton={false}
        scanQrButton={false}
        defaultWorkFlowStatus="Missed"
        allowWorkFlowStatusFilter={false}
        allowedColumns={[
          'OrderNumber',
          'CustomerName',
          'CustomerPhone',
          'RentalStart',
          'RentalEnd',
          'Location',
          'Delivery',
          'PaymentMethod',
          'AssignedUnit',
          'Amount',
          'CreatedBy',
          'Status',
        ]}
        additionalAction={
          <Button className="button-yellow !border-0 h-[46px]" onClick={() => doExport()} data-cy="export-all-orders">
            <Typography
              type="text-md"
              weight="semi-bold"
              className="flex justify-center justify-items-center gap-1 text-grey-700"
            >
              Export
            </Typography>
            <Icon icon="Export" size="medium" stroke="var(--grey-700)" />
          </Button>
        }
      />
      <SpinnerModal isOpen={isExporting} contentDescription="Exporting Missed Rentals" />
    </>
  );
};
